import { createFileRoute } from '@tanstack/react-router';
import { createServerFn } from '@tanstack/react-start';
import DestinationsPage from '../pages/DestinationsPage';
import { destinationMiddleware } from '../server/middleware/destinationMiddleware';

const loadDestination = createServerFn()
    .middleware([destinationMiddleware])
    .handler(async ({ context }) => {
        return context.destination;
    });

export const Route = createFileRoute('/destinations')({
    beforeLoad: async () => {
        try {
            const destination = await loadDestination();
            return { destination };
        } catch (error) {
            console.error('Failed to load destination:', error);
            throw error;
        }
    },
    loader: async ({ context }) => {
        const { destination } = context;
        return { destination };
    },
    // Server-rendered — see routes/index.jsx for why this replaces Helmet.
    head: ({ loaderData }) => {
        const destination = loaderData?.destination;
        const title = 'Wilderness Bookings | Destinations';
        const description = `Are you planning to go for a safari in ${destination?.name}? We have great accommodation and safari options in all major safari parks in East Africa plus we allow you to contact your future hosts directly.`;
        const image = destination?.images?.destination?.[0]?.url;
        const siteUrl = (destination?.url || '').replace(/\/$/, '');

        return {
            meta: [
                { title },
                { name: 'description', content: description },
                { property: 'og:title', content: title },
                { property: 'og:description', content: description },
                { property: 'og:type', content: 'website' },
                ...(siteUrl ? [{ property: 'og:url', content: `${siteUrl}/destinations` }] : []),
                ...(image ? [{ property: 'og:image', content: image }] : []),
            ],
        };
    },
    component: DestinationsPage,
    // ── Caching config 
    staleTime: 5 * 60 * 1000,   // reuse cached data for 5 mins on re-navigation
    gcTime: 10 * 60 * 1000,  // keep in memory for 10 mins after route unmounts
});